

import logo from "../assets/fitclubpro-icon.svg";
import { classNames } from "../helpers";


export default function FitClubProLogoText({ className, imageClassName }) {
  return (<div className="flex flex-row  items-center">
    {/* <img src={logo} alt="FitClub" className={classNames("w-1/2 sm:w-2/5 md:w-auto", className)} /> */}
    <h2 className="text-center text-4xl md:text-2xl font-bold tracking-tight text-brown-coffee">
      <span className="text-brown-coffee font-bold">
        <span className="text-portland-orange">
          Fit
        </span>Club Pro
      </span>
    </h2>
  </div>
  );
}
